import { render } from "./info-bill.vue?vue&type=template&id=df19db3a&scoped=true&ts=true"
import script from "./info-bill.vue?vue&type=script&lang=ts"
export * from "./info-bill.vue?vue&type=script&lang=ts"

import "./info-bill.vue?vue&type=style&index=0&id=df19db3a&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df19db3a"]])

export default __exports__